module.exports = __webpack_public_path__ + "img/youtube44x30.d3391c3c.png";